import { useGame } from "~/app";
import { XButton, XPlayerIcon, XTypography } from "~/jsx/components/design";
import { ModalNames } from "~/jsx/context/ModalNames";
import { useActions, useViewingPlayerOpt } from "~/jsx/hook";
import { Colors, Spacing } from "~/jsx/theme";
import { motion, SyncIcon, transition, useModal } from "~/utils";
import { XViewingPlayerResources } from "./XViewingPlayerResources";
import { XEventNavigator } from "../spectator/XEventNavigator";

export const XMenuBar = () => {
  const { syncStatus, game, update } = useGame();
  const { show: showHelp } = useModal(ModalNames.help);
  const { show: showHistory } = useModal(ModalNames.history);
  const viewingPlayer = useViewingPlayerOpt();
  const isYourTurn = viewingPlayer?.id === game.currentPlayer.id;

  const onAskUndo = () => {
    update({
      methodName: "askUndo",
      arg: undefined,
    });
  };

  return (
    <motion.div
      style={{
        minHeight: 32,
        backgroundColor: isYourTurn ? Colors.green.light : Colors.grey.e3,
        transition: transition(),
        boxShadow: "0px 6px 4px rgba(0, 0, 0, 0.12)",
        marginBottom: 10,
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        padding: 5,
      }}
    >
      <div style={{ display: "flex", alignItems: "center", gap: Spacing.px12 }}>
        <XTypography style={{ lineHeight: "100%" }}>
          <SyncIcon syncStatus={syncStatus} />
        </XTypography>
        <XButton variant="action" onClick={() => showHelp()}>
          Help
        </XButton>
        <XButton variant="action" onClick={() => showHistory()}>
          History
        </XButton>
        <XButton variant="action" onClick={onAskUndo}>
          Undo
        </XButton>
      </div>
      {!viewingPlayer && <XEventNavigator />}
      <div style={{ display: "flex", alignItems: "center" }}>
        <XViewingPlayerResources />
        {viewingPlayer && (
          <div style={{ marginLeft: Spacing.px12 }}>
            <XPlayerIcon width={24} playerId={viewingPlayer.id} />
          </div>
        )}
      </div>
    </motion.div>
  );
};
